<template>
    <form class="wrapper tab-phone" role="form" method="post" @submit.prevent="submit" novalidate>
        <header>
            <span class="new-headline-md text-centered">Damit wir Sie schnell erreichen können</span>

            <p class="new-text-lg text-centered text-color-default">Falls wir Rückfragen zu Ihrer Anfrage haben, erreichen wir Sie telefonisch am schnellsten.</p>
        </header>

        <div class="phone-form">
            <form-input-type-phone-number
                name="phone"
                label="Telefon"
                :errors="errors.phone"
                phoneCountry="de"
                full-border
                phone-country-disabled
            ></form-input-type-phone-number>

            <v-button type="submit" label="Weiter" :disabled="sending" full-width></v-button>

            <a href="#" class="phone-skip new-text-md" @click.prevent="skip">Weiter ohne Telefonnummer</a>
        </div>

        <div class="security-note">
            <figure>
                <img src="imgs/web/logo_iso_27001.png" alt="ISO 27001">
            </figure>

            <p class="new-text-md text-color-default">Ihre Daten sind nach ISO 27001 geschützt und werden ausschließlich für Ihren Zugang zu Vitadio verwendet.</p>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            sending: {
                type: Boolean,
                required: false,
                default: false
            },
            errors: {
                type: Object,
                required: false,
                default: () => ({})
            }
        },

        methods: {
            submit() {
                const number = ($('#phone').val() || '').trim()

                if (!number) {
                    this.$set(this.errors, 'phone', ['Bitte tragen Sie Ihre Telefonnummer ein.'])

                    Vuemit.fire('Button--sending-failed', true)

                    return
                }

                this.$emit('answer', { number, country: 'DE' })
            },

            skip() {
                this.$emit('answer', { number: null, country: null })
            }
        }
    }
</script>
